import { ReactElement } from 'react';

import { useLoadingDots } from '../../connectionCorrupted/useLoadingDots';
import { SystemMessage } from '../systemMessage';

export const AgentTypingAlert = ({ message }: { message: string }): ReactElement => {
	const dotsAmount = useLoadingDots();

	return (
		<SystemMessage className="operator_typing" message={message.replace(/[\.]+$/, '') + '.'.repeat(dotsAmount)} />
	);
};
